(function () {
    'use strict';

    angular
        .module('iMatApp')
        .factory('priceCalculationErrorHandler', priceCalculationErrorHandler);

    priceCalculationErrorHandler.$inject = ['issueFactory'];

    function priceCalculationErrorHandler(issueFactory) {
        return {
            handle: handle
        };

        // -------------------------------------------------------------------------------------

        function handle(reason) {
            switch (reason.code) {
                case 'DimensionsUnderLimit':
                    return issueFactory.createDimensionsUnderLimit(reason);
                case 'DimensionsBelowLimit':
                    return issueFactory.createDimensionsBelowLimit(reason);
                case 'DimensionsAboveLimit':
                    return issueFactory.createDimensionsAboveLimit(reason);
                case 'PriceLimit':
                    return issueFactory.createPriceLimit();
                case 'NoOnlinePrice':
                    return issueFactory.createNoOnlinePrice();
                default: //'PriceError':
                    return issueFactory.createPriceError();
            }
        }
    }
}());